export default __webpack_public_path__ + "static/gravel-bananatex-d4712c00b3c8488d685c9990b460d717.png";